module.exports = __webpack_public_path__ + "img/offline.591be52b.gif";